import { getValueSeverity } from './helpers';

const SENSOR_DEFINITIONS = [
  {
    key: 'temp1',
    label: 'Temperatura Ambiente 1',
    unit: 'degC',
    category: 'temperature',
    configKey: 'temperature',
    decimals: 1,
  },
  {
    key: 'temp2',
    label: 'Temperatura Ambiente 2',
    unit: 'degC',
    category: 'temperature',
    configKey: 'temperature',
    decimals: 1,
  },
  {
    key: 'temp_do1',
    label: 'Temp Sensor DO 1',
    unit: 'degC',
    category: 'temperature',
    configKey: 'temperature',
    decimals: 1,
  },
  {
    key: 'temp_do2',
    label: 'Temp Sensor DO 2',
    unit: 'degC',
    category: 'temperature',
    configKey: 'temperature',
    decimals: 1,
  },
  {
    key: 'do1_mgL',
    label: 'Oxigeno Disuelto 1',
    unit: 'mg/L',
    category: 'oxygen',
    configKey: 'oxygen',
    decimals: 2,
  },
  {
    key: 'do2_mgL',
    label: 'Oxigeno Disuelto 2',
    unit: 'mg/L',
    category: 'oxygen',
    configKey: 'oxygen',
    decimals: 2,
  },
  {
    key: 'sat1_pct',
    label: 'Saturacion 1',
    unit: '%',
    category: 'saturation',
    configKey: 'saturation',
    decimals: 1,
  },
  {
    key: 'sat2_pct',
    label: 'Saturacion 2',
    unit: '%',
    category: 'saturation',
    configKey: 'saturation',
    decimals: 1,
  },
];

const getAlertState = (value, thresholds) => {
  const severity = getValueSeverity(value, thresholds);
  if (!severity || severity === 'ideal') return null;

  if (severity === 'critical') {
    return value < thresholds.min
      ? { level: 'critical', direction: 'low', statusKey: 'critical-low' }
      : { level: 'critical', direction: 'high', statusKey: 'critical-high' };
  }

  return value < thresholds.idealMin
    ? { level: 'warning', direction: 'low', statusKey: 'warning-low' }
    : { level: 'warning', direction: 'high', statusKey: 'warning-high' };
};

const formatAlertValue = (value, decimals, unit) => {
  const formattedValue = Number(value).toFixed(decimals);
  return unit === 'degC' ? `${formattedValue} C` : `${formattedValue} ${unit}`;
};

const getThresholdDetail = (value, thresholds, direction, unit) => {
  const limitValue = direction === 'low'
    ? (value < thresholds.min ? thresholds.min : thresholds.idealMin)
    : (value > thresholds.max ? thresholds.max : thresholds.idealMax);

  const limitLabel = direction === 'low'
    ? (value < thresholds.min ? 'Minimo critico' : 'Minimo ideal')
    : (value > thresholds.max ? 'Maximo critico' : 'Maximo ideal');

  const formattedLimit = unit === 'degC'
    ? `${Number(limitValue).toFixed(1)} C`
    : `${Number(limitValue).toFixed(unit === '%' ? 1 : 2)} ${unit}`;

  return `${limitLabel}: ${formattedLimit}`;
};

const getDeviation = (value, thresholds, direction) => {
  if (direction === 'low') {
    if (value < thresholds.min) return thresholds.min - value;
    return thresholds.idealMin - value;
  }

  if (value > thresholds.max) return value - thresholds.max;
  return value - thresholds.idealMax;
};

const getRecommendedAction = (category, direction, level) => {
  const intensity = level === 'critical' ? 'de inmediato' : 'pronto';

  if (category === 'temperature') {
    return direction === 'high'
      ? `Revisar enfriamiento y recambio de agua ${intensity}.`
      : `Revisar calefaccion o condiciones ambientales ${intensity}.`;
  }

  if (category === 'oxygen') {
    return direction === 'high'
      ? `Verificar calibracion del sensor y nivel de aireacion ${intensity}.`
      : `Aumentar aireacion y revisar flujo de agua ${intensity}.`;
  }

  return direction === 'high'
    ? `Revisar nivel de aireacion y posible sobresaturacion ${intensity}.`
    : `Revisar oxigenacion y estado del sistema ${intensity}.`;
};

export const getRoomAlerts = (roomCode, data, sensorConfig, lastUpdate = Date.now()) => {
  if (!roomCode || !data || !sensorConfig) return [];

  return SENSOR_DEFINITIONS.reduce((alerts, sensor) => {
    const value = data[sensor.key];
    const thresholds = sensorConfig[sensor.configKey];
    const alertState = getAlertState(value, thresholds);

    if (!alertState) return alerts;

    alerts.push({
      id: `${roomCode}-${sensor.key}-${alertState.statusKey}-${lastUpdate}`,
      roomCode,
      sensorKey: sensor.key,
      sensorLabel: sensor.label,
      category: sensor.category,
      level: alertState.level,
      direction: alertState.direction,
      statusKey: alertState.statusKey,
      title: `${roomCode} en alerta`,
      message: `${sensor.label}: ${formatAlertValue(value, sensor.decimals, sensor.unit)}`,
      thresholdDetail: getThresholdDetail(value, thresholds, alertState.direction, sensor.unit),
      action: getRecommendedAction(sensor.category, alertState.direction, alertState.level),
      value,
      valueLabel: formatAlertValue(value, sensor.decimals, sensor.unit),
      deviation: getDeviation(value, thresholds, alertState.direction),
      createdAt: lastUpdate,
      isRead: false,
    });

    return alerts;
  }, []);
};
